import axios from 'axios';
import { csrfToken } from '@rails/ujs';

axios.defaults.headers.common = {
  // 'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN': csrfToken(),
};

// API は応答ごとに今のセッションの CSRF トークンを返す（app/controllers/concerns/api_csrf_protection.rb）。
// ログイン・ログアウトでセッション内のトークンが変わるので、受け取るたびに差し替える
const refreshCsrfToken = (headers): void => {
  const token = headers?.['x-csrf-token'];
  if (!token) return;
  const common = axios.defaults.headers.common;
  // 表記違い（X-CSRF-Token など）が残っていると送信時にそちらが勝つので消してから入れる
  Object.keys(common).filter(key => key.toLowerCase() === 'x-csrf-token').forEach(key => delete common[key]);
  common['X-CSRF-TOKEN'] = token;
  document.querySelector('meta[name="csrf-token"]')?.setAttribute('content', token);
};

axios.interceptors.response.use(
  response => {
    refreshCsrfToken(response.headers);
    return response;
  },
  error => {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }
  refreshCsrfToken(error.response?.headers);
  switch (error.response.status) {
    case 422:
    case 401:
    case 400:
    case 200:
      break;
    case 419:
      // CSRF トークンの不一致。サーバーが返す文言（再読み込みのお願い）を見せる
      alert(error.response.data?.error || 'ページを再読み込みしてから、もう一度お試しください。');
      break;
    case 429:
      // Rack::Attack の throttle。サーバーが返す文言をそのまま見せる
      alert(error.response.data?.error || 'しばらく時間をおいてから、もう一度お試しください。');
      break;
    default:
      console.error(error);
      alert('通信に失敗しました。しばらくおいて再度お試しください。');
      break;
  }
  return Promise.reject(error);
})

export default axios;
